import { Factory, StandardEntity } from '@infodata-group/inf-commons';
import { Alarm } from '../../model/alarm/alarm';
import { AlarmDto } from '../../dto/alarm/alarm.dto';
import { Gps } from '../../modules/shared/model/gps';

export class AlarmFactory implements Factory<Alarm> {
  getApi(): string {
    return 'alarms/';
  }
  build(o: AlarmDto): Alarm {
    const alarm = new Alarm(o.id, o.title);
    try {
      alarm.title = o.title;
      alarm.hour = o.hour;
      alarm.date = o.date;
      if (o.type) {
        alarm.type = new StandardEntity(o.type.id, o.type.label, 'label');
      }
      if (o.agent) {
        alarm.agent = new StandardEntity(
          o.agent.id,
          `${o.agent.lastname} ${o.agent.firstname}`,
          'label',
        );
      }
      if (o.client) {
        alarm.client = new StandardEntity(o.client.id, o.client.label, 'label');
      }
      if (o.site) {
        alarm.site = new StandardEntity(o.site.id, o.site.label, 'label');
      }
      if (o.material) {
        alarm.material = new StandardEntity(
          o.material.id,
          o.material.label,
          'label',
        );
      }
      if (o.tour) {
        alarm.tour = new StandardEntity(o.tour.id, o.tour.label, 'label');
      }
      if (o.tag) {
        alarm.tag = new StandardEntity(o.tag.id, o.tag.label, 'label');
      }
      if (o.status) {
        alarm.status = new StandardEntity(o.status.id, o.status.label, 'label');
      }
      alarm.comment = o.comment;
      alarm.remark = o.remark;
      if (o.location) {
        alarm.location = new Gps(
          o.location.lat,
          o.location.lng,
          o.location.alt,
          o.location.pre,
        );
      }
      if (o.tourGroup) {
        alarm.tourGroup = new StandardEntity(
          o.tourGroup.id,
          o.tourGroup.label,
          'label',
        );
      }
    } catch (err) {
      console.error(err);
    }
    return alarm;
  }
}
